// @ts-check
/** @typedef {import('../types/api').AdminAuthResponse} AdminAuthResponse */
/** @typedef {import('../types/api').AdminUser} AdminUser */

import { assertShape } from '../utils/apiGuards';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const adminAuthService = {
  /**
   * @param {string} email
   * @param {string} password
   * @returns {Promise<AdminAuthResponse>}
   */
  async login(email, password) {
    const response = await fetch(`${API_URL}/api/admin/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }

    const data = await response.json();
    assertShape(data, ['token', 'admin_user'], 'adminAuthService.login');
    localStorage.setItem('adminToken', data.token);
    localStorage.setItem('adminUser', JSON.stringify(data.admin_user));
    return data;
  },

  logout() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  },

  /** @returns {AdminUser|null} */
  getCurrentUser() {
    const userStr = localStorage.getItem('adminUser');
    return userStr ? JSON.parse(userStr) : null;
  },

  /** @returns {string|null} */
  getToken() {
    return localStorage.getItem('adminToken');
  },

  /** @returns {boolean} */
  isAuthenticated() {
    return !!this.getToken();
  },

  /** @returns {{Authorization: string, 'Content-Type': string}} */
  getAuthHeaders() {
    const token = this.getToken();
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  },
};

export default adminAuthService;
